import script from "./other.vue?vue&type=script&setup=true&lang=js"
export * from "./other.vue?vue&type=script&setup=true&lang=js"

import "./other.vue?vue&type=style&index=0&id=4b31b62c&lang=less&scoped=true"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b31b62c"]])

export default __exports__